import React, {forwardRef, useImperativeHandle, useState} from 'react'
import {ErrorMessage, Field} from 'formik'
import {PanelNalogDetaljiModel} from '../../../../models/ThermoPrometRolne'
import notifyToast from '../../../../components/Toast/Toast'
import {saveZapisiProizvodnje} from '../../../../api/zapisiProizvodnje'
import {useNavigate} from 'react-router-dom'
import UposlenikDropdown from "../../../../components/UposlenikDropdown/UposlenikDropdown";

interface Props {
    data: PanelNalogDetaljiModel
    values: { stavka: string; Smjena: string; Masina: string }
}

export type Ref = any

const Step2 = forwardRef<Ref, Props>(({data, values}, ref) => {
    const navigate = useNavigate()

    // 👉 NEW STATE
    const [potvrdjujemParametre, setPotvrdjujemParametre] = useState<'DA' | 'NE'>('NE')
    const [kontrolor, setKontrolor] = useState<string>('')

    useImperativeHandle(ref, () => ({
        saveData,
    }))

    const saveData = () => {
        // 🚫 VALIDATION
        if (potvrdjujemParametre === 'NE' && kontrolor) {
            notifyToast(false, 'Morate potvrditi parametre prije odabira kontrolora!')
            return
        }

        if (!kontrolor) {
            notifyToast(false, 'Molimo odaberite kontrolora kvaliteta!')
            return
        }

        const payload = {
            IdProizvodnje: data.id,
            BrojNaloga: data.brojNaloga,
            Stavka: values.stavka,
            Smjena: values.Smjena,
            Masina: values.Masina,

            kontrolor: kontrolor,
            potvrdjujemparametre: potvrdjujemParametre,
        }

        saveZapisiProizvodnje(payload)
            .then((response) => {
                notifyToast(true, response.message)
                const id = response.data.Id

                setTimeout(() => {
                    if (id) navigate(`/terminali/termopaneli/aktivni-nalozi/${id}`)
                }, 2000)
            })
            .catch((error) => notifyToast(false, error.response?.data?.message || 'Greška'))
    }

    return (
        <div className='w-100'>
            <div className='mb-10 fv-row'>
                <label className='d-flex align-items-center form-label mb-3'>
                    Nalog
                </label>
            </div>

            <div className='row mt-5'>
                {/* LEFT SIDE */}
                <div className='col-6'>
                    <table className='table table-bordered'>
                        <tbody>
                        <tr><th>ID: {data.id}</th></tr>
                        <tr><th>NALOG: {data.brojNaloga}</th></tr>
                        <tr><th>STAVKA: {data.stavka}</th></tr>
                        <tr><th>ARTIKAL: {data.artikal}</th></tr>
                        <tr><th>KUPAC: {data.kupac}</th></tr>
                        <tr><th>KOLIČINA: {data.kolicina}</th></tr>
                        <tr><th>NALOG KREIRAO: {data.kreiraoKorisnik}</th></tr>
                        <tr><th>BOJA GORNJEG LIMA: {data.boja_gore?.BojaNaziv}</th></tr>
                        <tr><th>BOJA DONJEG LIMA: {data.boja_dole?.BojaNaziv}</th></tr>
                        <tr><th>DEBLJINA GORNJEG LIMA: {data.debljina_gore?.debljina}</th></tr>
                        <tr><th>DEBLJINA DONJEG LIMA: {data.debljina_dole?.debljina}</th></tr>
                        </tbody>
                    </table>
                </div>

                {/* RIGHT SIDE 👉 NEW UI */}
                <div className='col-6'>
                    <div className='card p-5 shadow-sm'>

                        {/* POTVRDA */}
                        <div className='mb-5'>
                            <label className='form-label fw-bold'>
                                Potvrđujem da sam pregledao sve parametre prije startanja naloga
                            </label>

                            <select
                                className='form-select form-select-lg'
                                value={potvrdjujemParametre}
                                onChange={(e) =>
                                    setPotvrdjujemParametre(e.target.value as 'DA' | 'NE')
                                }
                            >
                                <option value='NE'>NE</option>
                                <option value='DA'>DA</option>
                            </select>
                        </div>

                        {/* KONTROLOR */}
                        <div className='mb-5'>
                            <label className='form-label fw-bold'>
                                Kontrolor kvaliteta
                            </label>

                            <UposlenikDropdown
                                value={kontrolor}
                                onChange={(name, value) => setKontrolor(value)}
                                errors={undefined}
                                touched={undefined}
                                selectName='kontrolor'
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
})

export {Step2}